<div ngbAccordion [closeOthers]="true" class="accordion-alt accordion-orders">
  <div ngbAccordionItem
    *ngFor="let order of orders | slice: (page - 1) * itemsPerPage : page * itemsPerPage; index as i"
    cardClass="border-top mb-0">
    <div ngbAccordionHeader>
      <button ngbAccordionButton class="accordion-button d-flex fs-4 fw-normal text-decoration-none py-3 collapsed"
        type="button">
        <!-- <div class="d-flex justify-content-between w-100" style="max-width: 440px;">
          <div class="me-3 me-sm-4">
            <div class="fs-sm text-muted">#{{order.orderNo}}</div>
            <span
              [ngClass]="{'bg-faded-warning text-warning': order.status === 'Pending', 'bg-faded-info text-info': order.status === 'Processing', 'bg-faded-success text-success': order.status === 'Completed', 'bg-faded-danger text-danger': order.status === 'Failed'}"
              class="badge fs-xs">{{getOrderStatusText(order)}}</span>
          </div>
          <div class="me-3 me-sm-4 d-none d-sm-block">
            <div class="d-none d-sm-block fs-sm text-muted mb-2">Data</div>
            <div class="d-sm-none fs-sm text-muted mb-2">Data</div>
            <div class="fs-sm fw-medium text-dark">{{order.submittedDate | date: 'MMM d, y, HH:mm':undefined:'ro'}}</div>
          </div>
          <div class="me-3 me-sm-4">
            <div class="fs-sm text-muted mb-2">Total</div>
            <div class="fs-sm fw-medium text-dark">{{order.amount}} lei</div>
          </div>
        </div> -->
        <div class="row w-100" style="max-width: 440px;">
          <div class="col-6 col-sm-4">
            <div class="fs-sm text-muted">#{{order.orderNo}}</div>
            <span
              [ngClass]="{'bg-faded-warning text-warning': order.status === 'Pending', 'bg-faded-info text-info': order.status === 'Processing', 'bg-faded-success text-success': order.status === 'Completed', 'bg-faded-danger text-danger': order.status === 'Failed'}"
              class="badge fs-xs">{{getOrderStatusText(order)}}</span>
            <i *ngIf="order.notificationDate" class="ai-time ms-2" ngbTooltip="Livrare programata catre {{order.recipientName}} ({{order.recipientEmail}}) pe data de {{order.notificationDate | date: 'MMM d, y':undefined:'ro'}}, ora {{order.notificationDate | date: 'HH:mm'}}"></i>
          </div>
          <div class="col-sm-5 order-3 order-sm-2 pt-3 pt-sm-0">
            <div class="d-none d-sm-block fs-sm text-muted mb-2">Data</div>
            <div class="d-sm-none fs-sm text-muted mb-2">Data</div>
            <div class="fs-sm fw-medium text-dark">{{order.submittedDate | date: 'MMM d, y, HH:mm':undefined:'ro'}}
            </div>
          </div>
          <div class="col-6 col-sm-3 order-2 order-sm-3 text-end">
            <div class="fs-sm text-muted mb-2">Total</div>
            <div class="fs-sm fw-medium text-dark">{{order.amount}} lei</div>
          </div>
        </div>

        <div class="accordion-button-img d-none d-sm-flex ms-auto">
          <div *ngFor="let voucherImage of getVoucherImages(order.orderItems)" class="mx-1">
            <img [src]="voucherImage" width="48">
          </div>
        </div>
      </button>
    </div>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="table-responsive pt-1">
        <ng-template>
          <table class="table align-middle w-100" style="min-width: 450px;">
            <tbody>
              <tr *ngFor="let orderItem of order.orderItems">
                <td class="border-0 py-1 px-0">
                  <div class="d-flex align-items-center">
                    <span class="d-inline-block flex-shrink-0 border border-1 rounded-1 p-md-2 p-lg-3">
                      <img [src]="getVoucherImage(orderItem)" width="110" [alt]="orderItem.voucherName">
                    </span>
                    <div class="ps-3 ps-sm-4">
                      <h4 class="h6 mb-2">{{orderItem.voucherName}}
                      </h4>
                    </div>
                  </div>
                </td>
                <td class="border-0 py-1 pe-0 ps-3 ps-sm-4">
                  <div class="fs-sm text-muted mb-2">Cantitate</div>
                  <div class="fs-sm fw-medium text-dark">{{orderItem.quantity}}</div>
                </td>
                <td class="border-0 py-1 pe-0 ps-3 ps-sm-4">
                  <div class="fs-sm text-muted mb-2">Valoare</div>
                  <div class="fs-sm fw-medium text-dark text-nowrap">{{orderItem.amount}} lei</div>
                </td>
                <td class="border-0 text-end py-1 pe-0 ps-3 ps-sm-4">
                  <div class="fs-sm text-muted mb-2">Total</div>
                  <div class="fs-sm fw-medium text-dark text-nowrap">{{orderItem.total}} lei</div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
      <div *ngIf="hasGiftCardFiles(order)" class="bg-secondary rounded-1 p-4 my-2">
        <div class="fs-sm fw-medium text-dark mb-1">Carduri cadou:</div>
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <a *ngFor="let giftCard of getGiftCardFiles(order)" (click)="downloadGiftCard(giftCard)"
            class="btn btn-link py-1 px-0 mt-2 d-inline-block text-truncate" role="button"><i
              class="ai-download me-2"></i>{{giftCard.name}}</a>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Pagination-->
<div *ngIf="canDisplayPagination && orders?.length" class="d-sm-flex align-items-center pt-4 pt-sm-5">
  <nav class="order-sm-2 ms-sm-auto mb-4 mb-sm-0" aria-label="Orders pagination">
    <ngb-pagination [(page)]="page" [collectionSize]="orders.length" [pageSize]="itemsPerPage" [maxSize]="5"
      [directionLinks]="false" [boundaryLinks]="false" [rotate]="true" size="sm" (pageChange)="onPageChanged()"
      class="d-flex justify-content-center"></ngb-pagination>
  </nav>
</div>
